import axios from 'axios'
import { SearchUrlParamBuilder } from '@/core/utils'

const URL_PATH = 'api/fornecedorItemAta'

class FornecedorApiClient {
	async buscarFornecedorPrincipalComAderentes(idItemAta) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/${idItemAta}/principal/comAderentes`,
		}).build()

		return await axios.get(url)
	}

	async buscarFornecedoresPorIdItemAtaPaginado(paginacao, idItemAta) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/${idItemAta}/todos`,
			pagingAndSorting: paginacao,
		}).build()

		return await axios.get(url)
	}

	async buscarFornecedorItemAtaPorId(id) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/${id}`,
		}).build()

		return await axios.get(url)
	}
}
export default new FornecedorApiClient()
